import { BillingSubscriptionsApiV1Subscription } from '@wix/ambassador-billing-subscriptions/types';

export const isRecurringSubscription = (subscription: BillingSubscriptionsApiV1Subscription) =>
  subscription?.billingSettings && (subscription.billingSettings?.totalCycles === undefined || subscription.billingSettings?.totalCycles > 1);

export const isPendingCancellationSubscription = (subscription: BillingSubscriptionsApiV1Subscription) =>
  isRecurringSubscription(subscription) && subscription.billingSettings?.cycleAutoRenew === false;
